<template>
	<div class="">
		<div style=" font-size: 60px;text-align: center;background: linear-gradient(to right,  orange, yellow, green, indigo, violet); height:700px;color:white">
			details
			details
			details
			details
		</div>

	</div>
</template>

<script>
	export default {
		name: 'homedetails',
		data() {
			return {}

		},
		created() {},
		methods: {

		}
	}
</script>
<style lang="scss" scoped>

</style>
